export const DistributorLocatorLoader = () => {
  return (
    <>
      {Array.from({ length: 2 }).map((_, index) => (
        <div key={index} className="rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
          <div className="flex items-start space-x-4">
            <div className="flex h-40 w-40 flex-shrink-0 items-center justify-center border">
              <div className="animate-glow h-20 w-20 rounded border border-gray-200 bg-gray-200" />
            </div>
            <div className="min-w-0 flex-1">
              <div className="animate-glow mb-2 h-6 w-3/4 rounded bg-gray-200" />
              <div className="animate-glow mb-2 h-4 w-1/2 rounded bg-gray-200" />
              <div className="animate-glow mb-2 h-4 w-2/3 rounded bg-gray-200" />
              <div className="animate-glow mb-2 h-4 w-1/3 rounded bg-gray-200" />
              <div className="animate-glow h-4 w-3/5 rounded bg-gray-200" />
            </div>
          </div>
        </div>
      ))}
    </>
  );
};
